import React, { ReactNode } from "react";
import { Stack } from "@chakra-ui/react";
import { isOrgWithEnterpriseAccess, useUser } from "@utils";

type PrivateBlockProps = {
  memberships?: string[];
  tiers?: string[];
  children: ReactNode;
};

export function PrivateBlock({
  memberships,
  tiers,
  children,
}: PrivateBlockProps) {
  const { user } = useUser();
  return user?.memberships
    .filter(isOrgWithEnterpriseAccess)
    .some(
      ({ account }) =>
        memberships?.includes(account.id) ||
        tiers?.includes(account.currentPlan.tier)
    ) ? (
    <Stack spacing="4">{children}</Stack>
  ) : null;
}
